<pt-mounting-material
  *ngIf="availableForMount$ | async as availableMaterials"
  [availableMountingMaterial]="availableMaterials.materials"
  [billOfMaterialArticleList]="availableMaterials.articles"
  (mountingMaterialSubmit)="onSelectClick($event)"
  [submitButtonLabel]="'MODAL_FOOTER.MOUNT'"
  [loadingTopic]="LOADING_TOPIC"
></pt-mounting-material>
